import React from 'react';
import './style.css';
const Contact = () => {
  return (
    <div className='content'>
      <h1>Orders Page</h1>
      <p>this page show you contact From</p>
    </div>
  );
};

export default Contact;
